export default {
  methods: {
    createSendAs ({userId, sendAsEmail, displayName, tokens}) {
      return this.$gapi.request({
        path: `https://www.googleapis.com/gmail/v1/users/${userId}/settings/sendAs`,
        method: 'POST',
        headers: {
          Authorization: `${tokens.token_type} ${tokens.access_token}`
        },
        body: {
          sendAsEmail: sendAsEmail,
          displayName: displayName,
          isDefault: false
        }
      })
    },
    deleteSendAs ({userId, sendAsEmail, tokens}) {
      return this.$gapi.request({
        path: `https://www.googleapis.com/gmail/v1/users/${userId}/settings/sendAs/${sendAsEmail}`,
        method: 'DELETE',
        headers: {
          Authorization: `${tokens.token_type} ${tokens.access_token}`
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/controlsGmailSendAs.js